import styled from "styled-components";
const StyledCategoryPage = styled.div`
  .header-style {
    display: flex;
    justify-content: space-between;
  }
  .first-category {
    font-size: 20px;
    font-weight: 500;
    text-align: left;
    margin-bottom: 16px;
  }
  .create-category-button {
    width: 170px;
    height: 34px;
    padding: 6.5px 29px 6.5px 30px;
    border-radius: 8px;
    border: 0.5px solid transparent;
    background-color: #c2fae5;
    cursor: pointer;
    margin-top: 5px;
  }

  .create-category-button:hover,
  .create-category-button:active {
    background-color: #c2fae5 !important;
    border: #c2fae5 !important;
    color: black !important;
  }
  .category-count-search {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 400;
  }
  .searchbar-style {
    color: #636980;
    border: 1px solid #e2e2e8;
    width: 210px;
    border-radius: 24px;
    font-size: 14px;
    font-weight: 400;
  }

  .custom-table {
    border: 1px solid #e2e2e8;
    border-radius: 8px;
  }

  .action-icons {
    visibility: hidden;
    display: flex;
    gap: 30px;
    align-items: center;
    margin-left: 20px;
  }

  .edit-icon {
    cursor: pointer;
    width: 25px;
    height: 25px;
  }

  .delete-icon {
    cursor: pointer;
    width: 25px;
    height: 25px;
  }
  .table-row-white,
  .table-row-gray {
    &:hover .action-icons {
      visibility: visible;
    }
  }

  .table-row-white {
    background-color: #ffffff;
  }

  .table-row-gray {
    background-color: #f5f5f5;
  }

  .label-style {
    color: #636980;
    font-weight: 500;
    font-size: 14px;
  }

  .modal-title {
    font-size: 18px;
    font-weight: 500;
  }

  .button-container {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    margin-top: 100px;
  }

  .cancel-button {
    width: 130px;
    height: 34px;
    border: 1px solid #1f243b;
    color: #1f243b;
    border-radius: 8px;
  }

  .cancel-button:hover,
  .cance-button:active {
    border: 1px solid #1f243b !important;
    color: #1f243b !important;
  }

  .create-button {
    width: 130px;
    height: 34px;
    border: none;
    background-color: #c2fae5;
    color: #1f243b;
    border-radius: 8px;
  }

  .create-button:hover,
  .create-button:active {
    background-color: #c2fae5 !important;
    border: none !important;
    color: #1f243b !important;
  }

  .modal-delete {
    width: 130px;
    height: 34px;
    padding: 6.5px 40.5px 6.5px 41.5px;
    border-radius: 8px;
    border: 1px solid #c2fae5;
    background-color: #c2fae5;
  }
`;

export default StyledCategoryPage;
